import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PageMetaWithTotalSchema } from '../pagination';
import { PollListItemSchema, PollStatusSchema } from './shapes';

export const ListPollsQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(25),
  cursor: z.string().optional(),
  q: z.string().trim().min(1).optional(),
  status: PollStatusSchema.optional(),
  createdBy: z.string().uuid().optional(),
});

export const listPolls = defineEndpoint({
  method: 'GET',
  path: '/v1/polls',
  params: z.object({}),
  query: ListPollsQuerySchema,
  body: z.undefined(),
  response: z.object({ data: z.array(PollListItemSchema), meta: PageMetaWithTotalSchema }),
});
